import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CapturaComponent } from './views/compra/captura/captura.component';
import { TicketComponent } from './views/compra/ticket/ticket.component';
import { CompaniesComponent } from './views/compra/companies/companies.component';
import { HistoryComponent } from './views/compra/history/history.component';



const routes: Routes = [{
  path: '',
  redirectTo: 'history',
  pathMatch: 'full'
},
{
  path: 'captura',
  component: CapturaComponent
},
{
  path:'ticket',
  component: TicketComponent
},
{
  path:'companies',
  component: CompaniesComponent
},
{
  path:'history',
  component: HistoryComponent
}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
